(function () {
  'use strict';

  const money = (cents) => `$${(Number(cents || 0) / 100).toFixed(2)}`;

  function loadVideo(video) {
    if (!video) return;
    const source = video.querySelector('source');
    if (source && !source.src && source.dataset.src) {
      source.src = source.dataset.src;
      video.load();
    }
  }

  function setMedia(root, type, src, alt, index) {
    const image = root.querySelector('[data-tb-main-image]');
    const video = root.querySelector('[data-tb-main-video]');
    const zoom = root.querySelector('[data-tb-open-zoom]');
    const counter = root.querySelector('[data-tb-gallery-counter]');
    const thumbs = Array.from(root.querySelectorAll('[data-tb-gallery-thumb]'));
    if (!image || !video || !src) return;

    if (type === 'video') {
      image.hidden = true;
      video.hidden = false;
      loadVideo(video);
      video.play().catch(() => {});
      if (zoom) zoom.hidden = true;
    } else {
      video.pause();
      video.hidden = true;
      image.hidden = false;
      image.src = src;
      image.removeAttribute('srcset');
      image.alt = alt || 'Reusable Pet Hair Remover Brush';
      if (zoom) zoom.hidden = false;
    }

    const numericIndex = Number.isInteger(index) ? index : thumbs.findIndex((thumb) => thumb.dataset.src === src);
    thumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === numericIndex;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
      if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    });

    root.dataset.tbGalleryIndex = numericIndex >= 0 ? String(numericIndex) : '-1';
    if (counter) counter.textContent = numericIndex >= 0 ? `${numericIndex + 1} / ${thumbs.length}` : 'Selected option';
  }

  function initGallery(root) {
    const gallery = root.querySelector('[data-tb-gallery]');
    if (!gallery || gallery.dataset.tbReady === 'true') return;
    gallery.dataset.tbReady = 'true';

    const thumbs = Array.from(gallery.querySelectorAll('[data-tb-gallery-thumb]'));
    const stage = gallery.querySelector('[data-tb-gallery-stage]');
    const prev = gallery.querySelector('[data-tb-gallery-prev]');
    const next = gallery.querySelector('[data-tb-gallery-next]');
    const mainImage = gallery.querySelector('[data-tb-main-image]');
    const openZoom = gallery.querySelector('[data-tb-open-zoom]');
    const lightbox = gallery.querySelector('[data-tb-lightbox]');
    const lightboxImage = gallery.querySelector('[data-tb-lightbox-image]');
    const closeZoom = gallery.querySelector('[data-tb-close-zoom]');

    const show = (index) => {
      if (!thumbs.length) return;
      const safeIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[safeIndex];
      setMedia(root, thumb.dataset.type || 'image', thumb.dataset.src, thumb.dataset.alt, safeIndex);
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    if (prev) prev.addEventListener('click', () => show(Number(root.dataset.tbGalleryIndex || 0) - 1));
    if (next) next.addEventListener('click', () => show(Number(root.dataset.tbGalleryIndex || 0) + 1));

    let startX = null;
    if (stage) {
      stage.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        startX = event.clientX;
      });
      stage.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        show(Number(root.dataset.tbGalleryIndex || 0) + (delta < 0 ? 1 : -1));
      });
      stage.addEventListener('pointercancel', () => { startX = null; });
    }

    const openLightbox = () => {
      if (!mainImage || mainImage.hidden || !lightbox || !lightboxImage) return;
      lightboxImage.src = mainImage.currentSrc || mainImage.src;
      lightboxImage.alt = mainImage.alt;
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
    };

    if (openZoom) openZoom.addEventListener('click', openLightbox);
    if (mainImage) mainImage.addEventListener('click', openLightbox);
    if (closeZoom) closeZoom.addEventListener('click', () => lightbox.close ? lightbox.close() : lightbox.removeAttribute('open'));
    if (lightbox) {
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close ? lightbox.close() : lightbox.removeAttribute('open');
      });
    }

    show(0);
  }

  function includedText(button) {
    const qty = button.dataset.qty;
    const display = button.dataset.display || '';
    if (qty === '1') return `1 remover in ${display}`;
    if (qty === '2' && display.includes(' + ')) {
      const [first, second] = display.split(' + ');
      return `1 ${first.toLowerCase()} + 1 ${second.toLowerCase()} remover`;
    }
    if (qty === '2') return `${display} removers`;
    if (qty === '3') return `${display} removers`;
    return `${button.dataset.qtyLabel} · ${display}`;
  }

  function initProduct(root) {
    if (root.dataset.tbProductReady === 'true') return;
    root.dataset.tbProductReady = 'true';

    const jsonNode = root.querySelector('[data-tb-variant-json]');
    if (!jsonNode) return;

    let variants = [];
    try {
      variants = JSON.parse(jsonNode.textContent);
    } catch (error) {
      console.error('Terbalo variant data could not be read.', error);
      return;
    }

    const variantById = new Map(variants.map((variant) => [String(variant.id), variant]));
    const optionButtons = Array.from(root.querySelectorAll('[data-tb-variant-button]'));
    const qtyButtons = Array.from(root.querySelectorAll('[data-tb-qty]'));
    const colorGroups = Array.from(root.querySelectorAll('[data-tb-color-group]'));
    const variantInput = root.querySelector('input[name="id"]');
    const addButton = root.querySelector('[data-tb-atc]');
    const addLabel = root.querySelector('[data-tb-atc-label]');
    const priceNode = root.querySelector('[data-tb-price]');
    const unitNode = root.querySelector('[data-tb-unit-price]');
    const saveNode = root.querySelector('[data-tb-save]');
    const badgeNode = root.querySelector('[data-tb-price-badge]');
    const qtyCurrent = root.querySelector('[data-tb-qty-current]');
    const colorCurrent = root.querySelector('[data-tb-color-current]');
    const includedNode = root.querySelector('[data-tb-included]');
    const stickyMeta = root.querySelector('[data-tb-sticky-meta]');
    const stickyButton = root.querySelector('[data-tb-sticky-button]');
    const defaultPairImage = root.dataset.defaultPairImage;
    const defaultProductImage = root.dataset.defaultProductImage;

    const preferredSkuByQty = {
      '1': 'CJGY103503903CX',
      '2': 'CJGY103503926ZA',
      '3': 'CJGY103503917QJ'
    };

    const selectedVariantButton = () => optionButtons.find((button) => button.classList.contains('is-selected'));

    function imageForVariant(variant, button) {
      if (variant.sku === 'CJGY103503926ZA') return defaultPairImage;
      if (variant.image) return variant.image;
      return button && button.dataset.qty === '2' ? defaultPairImage : defaultProductImage;
    }

    function updateVariant(button, updateUrl) {
      if (!button || button.disabled) return;
      const variant = variantById.get(String(button.dataset.variantId));
      if (!variant) return;

      optionButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      qtyButtons.forEach((item) => {
        const active = item.dataset.tbQty === button.dataset.qty;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      colorGroups.forEach((group) => { group.hidden = group.dataset.tbColorGroup !== button.dataset.qty; });

      variantInput.value = variant.id;
      variantInput.disabled = !variant.available;
      priceNode.textContent = money(variant.price);
      unitNode.textContent = `${button.dataset.unitPrice} each`;
      saveNode.textContent = button.dataset.savings ? `You save ${button.dataset.savings}` : 'Choose the option that fits your routine';
      badgeNode.textContent = button.dataset.badge || '';
      badgeNode.hidden = !button.dataset.badge;
      qtyCurrent.textContent = button.dataset.qtyLabel;
      colorCurrent.textContent = button.dataset.display;
      if (includedNode) includedNode.textContent = includedText(button);

      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available
        ? `${button.dataset.qty === '1' ? 'Add to Cart' : `Add ${button.dataset.qty}-Unit Set`} — ${money(variant.price)}`
        : 'Sold Out';

      if (stickyMeta) stickyMeta.textContent = `${button.dataset.qtyLabel} · ${button.dataset.display} — ${money(variant.price)}`;

      const image = imageForVariant(variant, button);
      if (image) setMedia(root, 'image', image, `${button.dataset.display} Reusable Pet Hair Remover`);

      if (updateUrl && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    qtyButtons.forEach((qtyButton) => {
      qtyButton.addEventListener('click', () => {
        const qty = qtyButton.dataset.tbQty;
        const preferredSku = preferredSkuByQty[qty];
        const preferred = optionButtons.find((button) => button.dataset.qty === qty && button.dataset.sku === preferredSku && !button.disabled);
        const firstAvailable = optionButtons.find((button) => button.dataset.qty === qty && !button.disabled);
        updateVariant(preferred || firstAvailable, true);
      });
    });

    optionButtons.forEach((button) => button.addEventListener('click', () => updateVariant(button, true)));
    if (stickyButton) stickyButton.addEventListener('click', () => addButton.click());

    const initial = selectedVariantButton()
      || optionButtons.find((button) => button.dataset.sku === 'CJGY103503926ZA')
      || optionButtons.find((button) => !button.disabled);
    updateVariant(initial, false);

    const sticky = root.querySelector('[data-tb-sticky]');
    if (sticky && addButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => sticky.classList.toggle('is-visible', !entry.isIntersecting));
      }, { threshold: 0.05 });
      observer.observe(addButton);
    }
  }

  function initLazyVideos(scope) {
    scope.querySelectorAll('[data-tb-lazy-video]').forEach((video) => {
      if (video.dataset.tbVideoReady === 'true') return;
      video.dataset.tbVideoReady = 'true';
      const wrapper = video.parentElement;
      const toggle = wrapper && wrapper.querySelector('[data-tb-video-toggle]');

      const play = () => {
        loadVideo(video);
        video.play().then(() => {
          if (toggle) {
            toggle.classList.add('is-playing');
            toggle.setAttribute('aria-label', 'Pause demonstration video');
          }
        }).catch(() => {});
      };

      const pause = () => {
        video.pause();
        if (toggle) {
          toggle.classList.remove('is-playing');
          toggle.setAttribute('aria-label', 'Play demonstration video');
        }
      };

      if (toggle) {
        toggle.addEventListener('click', () => video.paused ? play() : pause());
        video.addEventListener('click', () => video.paused ? play() : pause());
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.isIntersecting ? play() : pause());
        }, { rootMargin: '120px 0px', threshold: 0.18 });
        observer.observe(video);
      }
    });
  }

  function initAccordionGroups(scope) {
    scope.querySelectorAll('[data-tb-accordion-group]').forEach((group) => {
      if (group.dataset.tbAccordionReady === 'true') return;
      group.dataset.tbAccordionReady = 'true';
      group.querySelectorAll('details').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          group.querySelectorAll('details').forEach((other) => {
            if (other !== detail) other.open = false;
          });
        });
      });
    });
  }

  function initScrollButtons(scope) {
    scope.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-tb-scroll-buy]');
      if (!trigger) return;
      const target = document.querySelector('[data-tb-buybox]');
      if (!target) return;
      event.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  function init(scope) {
    scope.querySelectorAll('.tb-pdp').forEach((root) => {
      initGallery(root);
      initProduct(root);
    });
    initLazyVideos(scope);
    initAccordionGroups(scope);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init(document);
    initScrollButtons(document);
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
